import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
import { useQuery } from "@tanstack/react-query";

export function useFetchHomepageNewsAndHappeningsData(email) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "uuseFetchHomepageNewsAndHappeningsDataResultKey";

  async function GetNewsAndHappeningsData() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get(`/api/Landing/GetNewsAndNETRxHappenings`, {
        params: {
          email: email,
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, email],
    queryFn: async () => await GetNewsAndHappeningsData(),
    enabled: !IsNullOrEmpty(email),
  });
}
